import { formatDateWithDots, getPublicFileUrl } from "@pharmupp/p3-front-commons"
import type { ApiDisplayNews } from "../../../News/model"
import { newsRubricsReferential } from "../../referentials"
import type { FormattedNews } from "./News"

export const formatApiNews = <T extends ApiDisplayNews = ApiDisplayNews>(
  apiNews: T,
  isNewsFlash = false,
): FormattedNews => {
  const rubric = isNewsFlash
    ? "Flash Info Pharm-UPP"
    : newsRubricsReferential.find((rubric) => rubric.code === apiNews.rubric)
        ?.label || apiNews.rubric

  return {
    ...apiNews,
    rubric,
    publicationDate: formatDateWithDots(apiNews.publicationDate),
    image: apiNews.image ? getPublicFileUrl(apiNews.image) : undefined,
    logo: apiNews.logo ? getPublicFileUrl(apiNews.logo) : undefined,
  }
}
